interface TableVariableRendererProps {
  jsonArray: { [x: string]: string | number }[];
}

export default function TableVariableRenderer({ jsonArray }: TableVariableRendererProps) {
  // checking validation is if jsonAarray is array of object
  if (!Array.isArray(jsonArray)) {
    return null;
  }

  // remove the username if there is key named 'username' in jsonArray
  jsonArray = jsonArray.map(item => {
    if (item.username) {
      delete item.username;
    }
    return item;
  });

  return (
    <table className="table table-auto w-full text-sm bg-slate-50 text-left">
      <thead className="bg-sky-200">
        <tr>
          {Object.keys(jsonArray[0] ?? []).map((key, index) => (
            <th key={index} className="capitalize font-semibold p-3">
              {key}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {jsonArray?.map((item, index) => (
          <tr key={index}>
            {Object.values(item).map((value, index) => (
              <td key={index} className="p-3 whitespace-break-spaces">
                {value.toString()}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
